import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '@env/environment';
import { ReportType } from '@games/entities';
import { IReportType } from '@games/interfaces';

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  constructor(private http: HttpClient) {}

  getReportTypes(courseId: number, gameId: number): Observable<ReportType[]> {
    return this.http
      .get<any>(`${environment.apiUrl}courses/${courseId}/games/${gameId}/reports/`)
      .pipe(
        map((reportTypes: IReportType[]) =>
          reportTypes.map((reportType: IReportType) => new ReportType(reportType))
        )
      );
  }

  getReportData(courseId: number, gameId: number, period: number) {
    return this.http.post<any>(`${environment.apiUrl}courses/${courseId}/games/${gameId}/state/`, {
      period,
    });
  }

  getXLSReport(courseId: number, gameId: number): Observable<HttpResponse<Blob>> {
    return this.http.post<Blob>(
      `${environment.apiUrl}courses/${courseId}/games/${gameId}/xls_download/`,
      {},
      {
        observe: 'response',
        responseType: 'blob' as 'json',
      }
    );
  }

  getDdayReportHtml(
    courseId: number,
    gameId: number,
    reportId: number,
    period: number,
    entityId: number
  ): Observable<string> {
    return this.http.post(
      `${environment.apiUrl}courses/${courseId}/games/${gameId}/reports/${reportId}/get_url/`,
      { period, entity_id: entityId },
      { responseType: 'text' }
    );
  }
}
